import React, { useState } from 'react';
import Latex from 'react-latex-next';
import styled from 'styled-components';
import { AiFillCopy } from 'react-icons/ai';
import Snackbar from '@material-ui/core/Snackbar';

import {
  CalcSolution,
  SolutionWrapper,
  Parag,
  CopyButton,
} from '../../styled/stylezz';

const SpanBold = styled.span`
  &&& {
    font-size: 1.2em;
    font-size: bold;
    padding: 15px;
  }
`;

const SolutionCalc = ({ inputX: X, inputY: Y }) => {
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const sol = (100 * X) / Y;
  const propLatex = `$$\\frac{${Y}}{${X}} = \\frac{100}{x} \\; \\%$$`;
  const solLatex = `$$x=\\frac{100\\cdot${X}}{${Y}} = \\frac{${
    100 * X
  }}{${Y}} \\approx ${sol}\\;\\% \\quad$$`;

  const answerLatex = `$$${sol}\\;\\% \\quad$$`;

  const handleCopy = () => {
    navigator.clipboard.writeText(sol);
    setOpenSnackBar(true);
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackBar(false);
  };
  return (
    <SolutionWrapper>
      <>
        <Parag>Решение:</Parag>
        <CalcSolution style={{ textAlign: 'center' }}>
          <div>
            <SpanBold>{Y}</SpanBold> соответствует
            <SpanBold>{'100%'}</SpanBold>
          </div>
          <div>
            <SpanBold>{X}</SpanBold> соответствует
            <SpanBold>{'x%'}</SpanBold>
          </div>
        </CalcSolution>

        <Parag>Составим пропорцию:</Parag>
        <CalcSolution>
          <Latex>{propLatex}</Latex>
        </CalcSolution>
        <Parag>Решим полученное уравнение:</Parag>
        <CalcSolution>
          <Latex>{solLatex}</Latex>
        </CalcSolution>

        <Parag>Ответ:</Parag>
        <CalcSolution>
          <Latex>{answerLatex}</Latex>
          <CopyButton onClick={handleCopy}>
            <AiFillCopy
              size={20}
              style={{ color: '#5095df', marginRight: '10px' }}
            />
            Копировать ответ
          </CopyButton>
          <Snackbar
            achororigin={{
              vertical: 'center',
              horizontal: 'center',
            }}
            open={openSnackBar}
            autoHideDuration={2000}
            message="Ответ скопирован"
            onClose={handleClose}
            ContentProps={{
              style: {
                background: '#5095df',
              },
            }}
          />
        </CalcSolution>
      </>
    </SolutionWrapper>
  );
};

export default SolutionCalc;
